/**
 * Factory file for product related data.
 *
 * @exports products
 * @category Factories
 */
export default {
  /**
   * Get a a product based on parameters.
   *
   * @param {object} projectProductData
   * @returns {object}
   */
  getProjectProduct(projectProductData = {}) {
    return {
      alternative: false,
      id: 1,
      label: 'Basic Life / AD&D',
      prior_coverage: true,
      product_type_id: 4,
      product_type_name: 'Basic Life',
      state: 'not_started',
      ...projectProductData,
    };
  },
};
